module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.systemsList) ? _c('ul', _vm._l((_vm.systemsList), function(system) {
    return _c('li', {
      key: system.iconFile,
      on: {
        "click": function($event) {
          return _vm.selectItem(system)
        }
      }
    }, [_c('img', {
      attrs: {
        "width": "70px",
        "src": _vm._f("s3Image")(("systems_icons/" + (system.iconFile))),
        "alt": ""
      }
    }), _vm._v("\n      " + _vm._s(system.name) + "\n    ")])
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f94a277","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/configuration/SystemsList.vue
// module id = 1493
// module chunks = 4